import { useTranslation } from 'react-i18next';
import styles from './SuspenseLoader.module.scss';

const SuspenseLoader = () => {
  const { t } = useTranslation(['common'], { useSuspense: false });

  return (
    <div
      className={styles.loader}
      role="status"
      aria-live="polite"
      aria-label={t('common:loadingApp')}
    >
      <div className="logo-word" aria-hidden="true"></div>
      <div className="boot-status">
        <span id="boot-text">{t('common:loadingApp')}</span>
      </div>
    </div>
  );
};

export default SuspenseLoader;
